import script from "./ProductDetailSaleVariant.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailSaleVariant.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailSaleVariant.vue?vue&type=style&index=0&id=367c940c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367c940c"]])

export default __exports__